import React from "react";
import HeroSection from "../../components/HeroSection";
import ServicesSection from "../../components/ServicesSection";
import AccessSection from "../../components/AccessSection";
import ProgrammeSection from "../../components/programmee/programmee";
import './homePage.css';
import TestimonialSection from "../../components/testimonial";
import LogoMarquee from "../../components/marquee";
import TrialForm from "../../components/form/form";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <AccessSection />
      <ProgrammeSection />
      <TestimonialSection />
      <LogoMarquee />
      <section id="trial-form-section">
        <TrialForm isHomePage={true} />
      </section>
    </>
  );
};

export default HomePage;
